var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEraser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4478 33.2752H24.8505L37.7624 19.8635L37.7631 19.8627C38.3967 19.2005 38.7501 18.3107 38.7501 17.3856C38.7501 16.4605 38.3967 15.5706 37.7631 14.9085L37.7616 14.9069L27.0816 3.88264L27.072 3.87276L27.0617 3.86366L26.8987 3.71992C26.8984 3.71964 26.8981 3.71937 26.8977 3.7191C26.241 3.13214 25.3908 2.82111 24.5178 2.85122C23.6443 2.88134 22.8163 3.25052 22.1995 3.88152L22.1981 3.88304L2.23926 24.5505L2.23788 24.552C1.60376 25.2161 1.2501 26.1079 1.2501 27.0349C1.2501 27.9618 1.60376 28.8536 2.23788 29.5178L2.23927 29.5192L9.50451 37.0424L9.60771 37.1492H9.75628H33.4478H33.7978V36.7992V33.6252V33.2752H33.4478ZM10.7619 21.2074L24.6338 6.877L34.8214 17.4277L20.9776 31.7292L10.7619 21.2074ZM11.2002 33.2752L5.17898 27.0345L8.10314 23.9948L17.1235 33.2752H11.2002Z",
    fill: "#0046AD",
    stroke: "#0046AD",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/eraser.39771bbe92e23f46bee0b1dbeb61b9da.svg";
export { ForwardRef as ReactComponent };